import React from 'react';
import BrandLogo from './BrandLogo';

type BrandLockupSize = 'sm' | 'md' | 'lg';

interface BrandLockupProps {
  logoUrl?: string | null;
  platformName?: string | null;
  platformTagline?: string | null;
  size?: BrandLockupSize;
  centered?: boolean;
  showTagline?: boolean;
  className?: string;
  logoClassName?: string;
}

const logoSizeClasses: Record<BrandLockupSize, string> = {
  sm: 'h-9 w-9 sm:h-10 sm:w-10 lg:h-11 lg:w-11',
  md: 'h-12 w-12',
  lg: 'h-14 w-14 sm:h-16 sm:w-16',
};

const nameClasses: Record<BrandLockupSize, string> = {
  sm: 'text-base sm:text-lg lg:text-2xl',
  md: 'text-2xl',
  lg: 'text-2xl sm:text-3xl',
};

const BrandLockup: React.FC<BrandLockupProps> = ({
  logoUrl,
  platformName,
  platformTagline,
  size = 'md',
  centered = false,
  showTagline = true,
  className = '',
  logoClassName = '',
}) => {
  const displayName = platformName?.trim() || '';
  const tagline = platformTagline?.trim();

  if (!logoUrl && !displayName) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2.5 sm:gap-3 min-w-0 ${centered ? 'justify-center' : ''} ${className}`}>
      <BrandLogo
        logoUrl={logoUrl}
        platformName={displayName}
        size="md"
        className={`${logoSizeClasses[size]} ${logoClassName}`}
      />
      <div className={`flex flex-col min-w-0 ${centered ? 'items-start text-left' : ''}`}>
        <span className={`${nameClasses[size]} font-extrabold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent leading-tight truncate`}>
          {displayName}
        </span>
        {showTagline && tagline && (
          <span className="text-xs text-gray-500 dark:text-gray-400 font-medium -mt-0.5 truncate">
            {tagline}
          </span>
        )}
      </div>
    </div>
  );
};

export default BrandLockup;
